"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { Time } from "@/helpers/time";
import { useCompactMode } from "@/contexts/CompactModeContext";
type WaveDropTimeSize = "xs" | "sm";
interface WaveDropTimeProps {
  readonly timestamp: number;
  readonly size?: WaveDropTimeSize;
}

/**
 * A reusable component for displaying timestamps in wave drops
 * Uses the exact same logic as the original WaveDropHeader implementation
 */
const SIZE_CLASSES: Record<WaveDropTimeSize, string> = {
  xs: "tw-text-xs",
  sm: "tw-text-sm"
};
const WaveDropTime: React.FC<WaveDropTimeProps> = t0 => {
  const $ = _c(10);
  const {
    timestamp,
    size: t1
  } = t0;
  const size = t1 === undefined ? "xs" : t1;
  const [isMobile, setIsMobile] = useState(false);
  const compact = useCompactMode();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const checkMobile = function checkMobile() {
        const screenSize = window.innerWidth;
        if (screenSize <= 640) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      };
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  if (!timestamp) {
    return null;
  }
  let t4;
  if ($[2] !== isMobile || $[3] !== timestamp) {
    t4 = () => {
      const timeObj = Time.millis(timestamp);
      const date = new Date(timestamp);
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();
      if (isToday) {
        return date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      if (isMobile) {
        return timeObj.toLocaleDropDateString();
      } else {
        const yesterday = new Date();
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.toDateString() === yesterday.toDateString();
        const timeStr = date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit"
        });
        if (isYesterday) {
          return `Yesterday - ${timeStr}`;
        }
        const sameYear = date.getFullYear() === now.getFullYear();
        const dateStr = date.toLocaleDateString(undefined, {
          month: "short",
          day: "2-digit",
          ...(sameYear ? {} : {
            year: "numeric"
          })
        });
        return `${dateStr} - ${timeStr}`;
      }
    };
    $[2] = isMobile;
    $[3] = timestamp;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const formatTime = t4;
  const textSizeClass = compact ? "tw-text-[11px] tw-leading-4" : SIZE_CLASSES[size];
  const t5 = `${textSizeClass} tw-mb-0 tw-whitespace-nowrap tw-leading-none tw-text-white/40`;
  let t6;
  if ($[5] !== formatTime) {
    t6 = formatTime();
    $[5] = formatTime;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <p className={t5}>{t6}</p>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default WaveDropTime;